export default __webpack_public_path__ + "static/media/gift-icon.d017b8ae.svg";